import { Controller } from "@hotwired/stimulus"

// Révèle d'un coup les entrées qu'une liste garde repliées, et efface son propre bouton.
//
// LES ENTRÉES SONT DÉJÀ DANS LE DOCUMENT, rendues puis masquées par le serveur : le bouton ne
// déclenche aucune requête, et un moteur de recherche lit la liste entière. C'est aussi pourquoi
// l'état de repli est posé au rendu — calculé ici au montage, la liste complète apparaîtrait le
// temps d'une image avant de se replier sous les yeux du visiteur.
//
// TOUT D'UN COUP plutôt que lot par lot : la suite d'une liste de lignes compactes tient dans un
// écran, et un « Voir plus » qui en révèle trois à la fois fait perdre des clics pour rien.
export default class extends Controller {
  static targets = ["item", "button"]

  reveal() {
    this.itemTargets.forEach((item) => item.classList.remove("hidden"))
    // Le bouton disparaît plutôt que de rester désactivé : il n'a plus rien à révéler, et un
    // contrôle inerte laisse chercher ce qu'il commande encore.
    this.buttonTarget.hidden = true
  }
}
